// extracted by mini-css-extract-plugin
export default {"client-profile-content":"client-profile-access-settings_client-profile-content__7WrGZ"};